import React from "react";
import { Badge, colors } from "../design/badge";
import { ChildSupportPayment } from "../models/ChildSupportPayment";

const ChildSupportPaymentStatusBadge: React.FC<{
  status: ChildSupportPayment["status"];
}> = ({ status }) => {
  let color;
  let title;
  switch (status) {
    case "paid":
      color = "green";
      title = "Paid";
      break;
    case "missed":
      color = "red";
      title = "Missed";
      break;
    case "partial":
      color = "yellow";
      title = "Partial";
      break;
    case "pending":
      color = "blue";
      title = "Pending";
      break;
    default:
      color = "gray";
      title = status;
      break;
  }
  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default ChildSupportPaymentStatusBadge;
